import { ToastContainer } from './ToastContainer';

export const ToastProvider = () => {
  return <ToastContainer />;
};
